"use client";

import { useEffect } from "react";
import { onCLS, onLCP, onTTFB, onINP, onFCP, type Metric } from "web-vitals";

type Sender = (metric: Metric) => void;

function logToConsole(metric: Metric) {
  if (process.env.NODE_ENV !== 'production') {
    console.info(`[WebVitals] ${metric.name}:`, Math.round(metric.value), metric);
  }
}

export default function WebVitals({ send }: { send?: Sender }) {
  useEffect(() => {
    const sink: Sender = send || (async (metric) => {
      logToConsole(metric);
      try {
        await fetch('/api/rum', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(metric),
          keepalive: true,
        });
      } catch {
        // noop
      }
    });
    onCLS(sink);
    onLCP(sink);
    onTTFB(sink);
    onINP?.(sink);
    onFCP?.(sink);
  }, [send]);

  return null;
}


